<template lang="pug">
  .main-content-padded.main-content-nopad-small
    .row
      .col.s12
        .bcrumb
          a(href='#') Settings
    .row
      .col.s12.m4
        form.row.card-panel(@submit.prevent='updateSettings')
            .input-field.col.s12.m12
              input#deliveryFee.validate(type='number' v-model='deliveryFee' min='0')
              label.active(for='deliveryFee') Delivery Fee
            .col.s12
              button.btn.indigo Update
      .col.m1
      .col.s12.m4
        .row.card-panel
            .input-field.col.s12.m12
              p
                label
                  input.with-gap(name="group1" type="radio" v-model="selectedSched" v-bind:value="sched1" )
                  span Monday to Thursday: 9 am to 6pm
              p
                label
                  input.with-gap(name="group1" type="radio" v-model="selectedSched"  v-bind:value="sched2" )
                  span Friday to Sunday:  9 am to 10pm 
              label.active Delivery Schedule
            .col.s12
              button.btn.indigo(@click='updateDeliverySchedule(selectedSched)') Update
              
        
</template>
<script>
import axios from 'axios'
export default {
  meta: {
    title: 'Settings'
  },
  data () {
    return {
      lst: [],
      selectedSched: null,
      sched1: 'Monday to Thursday: 9 am to 6pm',
      sched2: 'Friday to Sunday:  9 am to 10pm'
    }
  },
  created () {
    this.$store.dispatch('config/getFees')
  },
  mounted () {
    // this.getSchedule()
    this.getSched()
  },
  computed: {
    // selectedSched () {
    //   return this.$store.state.config.schedule.deliveryschedule
    // },
    deliveryFee: {
      get () {
        return this.$store.state.config.fees.delivery
      },
      set (deliveryFee) {
        return this.$store.commit('config/setDeliveryFee', deliveryFee)
      }
    }
  },
  methods: {
    getSchedule () {
      this.selectedSched = this.$store.state.config.schedule.deliveryschedule
    },
    updateSettings () {
      this.$store.dispatch('config/updateSettings').then(() => {
        this.$snackbar.success('Delivery Fee updated')
      })
    },
    updateDeliverySchedule () {
      this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        axios.post(`${process.env.API_URL}/admin/settings`, {
          settings: [{
            propertyType: 'DeliverySchedule',
            propertyValue: this.selectedSched
          }]
        }, {
          headers: {
            authorization: `Bearer ${accessToken}`
          }
        }).then(result => {
          this.$snackbar.success('Delivery Schedule updated')
        })
      })
    },
    getSched () {
      this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        axios.get(`${process.env.API_URL}/admin/settings`, {
          headers: {
            authorization: `Bearer ${accessToken}`
          }
        }).then(result => {
          this.selectedSched = result.data[1].propertyValue
        })
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/page-settings.vue